

































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import Nav from "@/components/nav/navBar.vue";
import * as types from "@/store/constants/types";
import ScrollView from "@/components/scroll/flipScroll.vue";
import PaymentInfo from "./paymentInfo/PaymentInfo.vue";
import PaymentSelect from "./paymentSelect/PaymentSelect.vue";
import { isIos } from "@/utils/lodash";
import BakcPress from "@/utils/backPress";
import { updateEventObj } from "@/utils/sendEventUtil";
import VipNav from "./vipNav/vipNav.vue";
import { initialProcessState } from "@/utils/initialProcessState";
import EventBus from "@/utils/eventBus";
import SuperPayPaymentClose from "@/components/superPay/superPayPaymentClose/superPayPaymentClose.vue";
import SuperPayAndBackUpHelpers, { TEMP_KEY } from "@/utils/superPayAndBackUp";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
    Nav,
    ScrollView,
    PaymentInfo,
    PaymentSelect,
    VipNav,
    SuperPayPaymentClose
  }
})
export default class PaymentContainer extends Vue {
  @Getter(types.GETTER_MASTER_COINS) private userCoins: any;
  @Getter(types.GETTER_SUPER_PAY_PARAMS) private superPayParams: any;
  @Getter(types.GETTER_SUPER_PAY_PAYMENT_CLOSE_SHOW_RETAIN_ENABLE)
  private superPayPaymentCloseRetainShowEnable: any;
  @Getter(types.GETTER_SUPER_PAY_PAYMENT_IAP_CANCEL_DIALOG_ENABLE)
  private superPayPaymentIapCancleShowEnable: any;
  @Getter(types.GETTER_SUPER_PAY_SWITCH_TO_IAP_DIALOG_SHOW_ENABLE)
  private superPaySwitchToIapDialogShowEnable: any;
  @Getter(types.GETTER_CURRENT_INS_USER_INFO) private currentUserInfo: any;
  @Getter(types.GETTER_SUPER_PAY_APP_INSTALLED_STATUS)
  private superPayAppInstalledStatus: any;
  @Getter(types.GETTER_BACK_UP_APP_INSTALLED_STATUS)
  private backUpAppInstalledStatus: any;
  @Action(types.PAY_BY_IAP) private payByIap: any;
  @Action(types.PAY_BY_CREDIT_CARD) private payByCreditCard: any;
  @Action(types.PAY_BY_PAY_PAL) private payByPaypal: any;
  @Action(types.ROUTER_GO_BACK) private routerGoBack: any;
  @Action(types.ROUTER_PUSH) private routerPush: any;
  @Mutation(types.UPDATE_RECOMMEND_ORDER_STATUS)
  private updateRecomOrderStatus: any;
  @Action(types.PAY_BY_SUPER_PAY) private payBySuperPay: any;
  @Action(types.DIALOG_SHOW) private diaLogShow: any;
  @Action(types.DIALOG_HIDE) private dialogHide: any;
  @Action(types.START_INSTALL_SUPER_PAY_APP)
  private startInstallSuperPayApp: any;
  @Getter(types.GETTER_SUPER_PAY_PARAMS) private superPayAppParams: any;
  @Getter(types.GETTER_SUPER_PAY_APP_DESC_LIST)
  private superPayAppDescList: any;

  private limitedTimer: any = null; //用来计时的timer,在组件销毁后清除timer
  private timeString: string = ""; //显示的时间字符串
  private timeDefault: number = 10 * 60; //默认规定的时间内支付，否则关闭
  private payWay?: string = "paypal"; //支付方式
  private superpayRetainShow: boolean = false;
  private hasPayBySuperPayToastShowed: boolean = false;

  private cancelledPay(error: any) {
    if (
      error.error &&
      typeof error.error === "string" &&
      error.error.indexOf("ancelled") > -1
    ) {
      this.payWay = "iap";
      this.clickPay();
    }
  }

  @Watch("payWay", { immediate: true })
  private changeSelectWay(val: string, oldVal: string) {
    console.log("watch payWay>>>>>>:", {
      val,
      oldVal
    });
    if (val && oldVal && (val === "iap" && oldVal === "super_pay")) {
      this.saveSwitchToIap();
      if (
        this.superPaySwitchToIapDialogShowEnable() &&
        !this.hasPayBySuperPayToastShowed
      ) {
        SuperPayAndBackUpHelpers.addTempKeyTimes(
          TEMP_KEY.TEMP_SUPER_PAY_DIALOG_OR_RETAIN_SHOW_TIMES
        ); //记录互斥次数

        this.showIapSwitchDialog();
      }
    }
  }

  get descListData() {
    return this.superPayAppDescList();
  }

  private showIapSwitchDialog() {
    const iconSrc = require("@/assets/icons-file/super_pay/vip_video_ok.png");
    const liStyle = "display:flex;align-items:center;padding-top:14px;";
    const firstLiStyle = "display:flex;align-items:center;padding-top:0;";
    const iconStyle = "width:20px;margin-right:8px";
    const pStyle =
      "font-size:14px;line-height:20px;color:rgb(140,140,140);text-align:left";

    let listString: string = ``;
    this.descListData &&
      this.descListData.forEach((item: string, index: number) => {
        listString += `<li style="${index === 0 ? firstLiStyle : liStyle}">
            <img
                src="${iconSrc}"
                style="${iconStyle}"
              />
            <p style="${pStyle}">${item}</p> 
          </li>`;
      });

    const dialogObj: any = {
      title: "Are You Sure?",
      midContent: `
        <ul>
          ${listString}
        </ul>
      `,
      buttons: [
        {
          text: "GET DISCOUNT",
          leftIcon: require("@/assets/icons-file/super_pay/icon_super_down@3x.png"),
          clickFn: async () => {
            this.startInstallSuperPayApp({
              ga: "super_pay_switch_to_iap"
            });
            this.payWay = "super_pay";
          },
          bgColor: "rgb(0,192, 188)"
        },
        {
          text: "NOT NOW",
          clickFn: () => {}
        }
      ],
      closeImgShow: false,
      topIcon: require("@/assets/icons-file/super_pay/earn_feed_super_discount@3x.png")
    };

    this.diaLogShow(dialogObj);

    //打点：
    sendEventWithParams("uia_recommend_app_show", {
      super_pay: "super_pay_switch_to_iap"
    });
  }

  private showPaymentCloseDialog() {
    const iconSrc = require("@/assets/icons-file/super_pay/vip_video_ok.png");
    const liStyle = "display:flex;align-items:center;padding-top:14px;";
    const firstLiStyle = "display:flex;align-items:center;padding-top:0;";
    const iconStyle = "width:20px;margin-right:8px";
    const pStyle =
      "font-size:14px;line-height:20px;color:rgb(140,140,140);text-align:left";

    let listString: string = ``;
    this.descListData &&
      this.descListData.forEach((item: string, index: number) => {
        listString += `<li style="${index === 0 ? firstLiStyle : liStyle}">
            <img
                src="${iconSrc}"
                style="${iconStyle}"
              />
            <p style="${pStyle}">${item}</p> 
          </li>`;
      });

    const dialogObj: any = {
      title: "Discount App Required",
      midContent: `
        <ul>
          ${listString}
        </ul>
      `,
      buttons: [
        {
          text: "GET DISCOUNT",
          leftIcon: require("@/assets/icons-file/super_pay/icon_super_down@3x.png"),
          clickFn: async () => {
            this.startInstallSuperPayApp({
              ga: "payment_close"
            });
          },
          bgColor: "rgb(0,192, 188)"
        },
        {
          text: "NOT NOW",
          clickFn: () => {
            this.normalCloseProcess();
          }
        }
      ],
      closeImgShow: false,
      topIcon: require("@/assets/icons-file/super_pay/earn_feed_super_discount@3x.png")
    };

    this.diaLogShow(dialogObj);

    //打点：
    sendEventWithParams("uia_recommend_app_show", {
      super_pay: "payment_close"
    });
  }

  private showSuperPayDialog(ga?: string) {
    EventBus.$emit("show-super-pay-toast", {
      show: true,
      ga,
      closeFn: () => {
        this.clickSuperPayDialogClose();
      }
    });
  }

  private saveSwitchToIap() {
    SuperPayAndBackUpHelpers.addTempKeyTimes(TEMP_KEY.TEMP_SWITCH_TO_IAP_TIMES);
  }

  private saveCloseTimes() {
    SuperPayAndBackUpHelpers.addTempKeyTimes(TEMP_KEY.TEMP_PAYMEN_CLOSE_TIMES);
  }

  private saveCancleIapTimes() {
    SuperPayAndBackUpHelpers.addTempKeyTimes(TEMP_KEY.TEMP_IAP_CANCEL_TIMES);
  }

  private clickSuperPayDialogClose() {
    EventBus.$emit("show-super-pay-toast", {
      show: false
    });
  }

  private checkShowSuperPayDialog() {
    if (this.superPayPaymentIapCancleShowEnable()) {
      SuperPayAndBackUpHelpers.addTempKeyTimes(
        TEMP_KEY.TEMP_SUPER_PAY_DIALOG_OR_RETAIN_SHOW_TIMES
      ); //记录互斥次数
      this.showSuperPayDialog("iap_cancel");
      //打点：
      sendEventWithParams("uia_recommend_app_show", {
        super_pay: "iap_cancel"
      });
    }
  }

  private clicksuperPayRetainClose() {
    this.superpayRetainShow = false;
    this.normalCloseProcess();
  }

  private created() {
    this.dialogHide();
  }

  private mounted() {
    BakcPress.listen({
      key: this.$route.name,
      fn: () => {
        this.clickClose();
      }
    });

    //页面流向
    sendEvent("page_view", "payment");
    const params: any = this.$route.params;
    if (params.hasOwnProperty("type") && params.type === 1) {
      this.payWay = "iap";
      setTimeout(() => {
        this.payByIap({ offer: this.offer }).catch((err: any) => {});
      }, 1000);
    }
  }

  private activated() {
    console.log("payment activated:", this.$route.params);
  }

  private destroyed() {
    clearInterval(this.limitedTimer);
  }

  private normalCloseProcess() {
    updateEventObj(null);
    this.updateRecomOrderStatus(null);
    BakcPress.destroy(this.$route.name as any);
    if (this.$route.params.type) {
      this.routerGoBack(-2);
    } else {
      this.routerGoBack(-1);
    }
    if (initialProcessState.recommendOffer) {
      EventBus.$emit(
        "recommend-offer-show",
        initialProcessState.recommendOffer
      );
    }
  }

  private clickClose() {
    this.saveCloseTimes();
    console.log("clickClose:", {
      a: this.superPayPaymentCloseRetainShowEnable(),
      t: this.hasPayBySuperPayToastShowed
    });
    //判断是否触发super pay的挽留：
    if (
      this.superPayPaymentCloseRetainShowEnable() &&
      !this.hasPayBySuperPayToastShowed
    ) {
      SuperPayAndBackUpHelpers.addTempKeyTimes(
        TEMP_KEY.TEMP_SUPER_PAY_DIALOG_OR_RETAIN_SHOW_TIMES
      ); //记录互斥次数

      // this.superpayRetainShow = true;
      this.showPaymentCloseDialog();
    } else {
      this.normalCloseProcess();
    }
  }

  private clickPay() {
    console.log("this.payWay", this.payWay);
    //点击支付按钮：
    if (this.payWay === "iap") {
      this.payByIap({ offer: this.offer }).catch((error: any) => {
        console.log("payByIap errro:", error);
        if (
          error.error &&
          typeof error.error === "string" &&
          error.error.indexOf("ancelled") > -1
        ) {
          this.saveCancleIapTimes();
          //取消购买：
          this.checkShowSuperPayDialog();
        }
      });
    } else if (this.payWay === "paypal") {
      this.payByPaypal(this.offer).catch((error: any) => {
        console.log("error", error);
        this.cancelledPay(error);
      });
    } else if (this.payWay === "super_pay") {
      //检查是否安装了super_pay APP:
      if (this.superPayAppInstalledStatus) {
        this.payBySuperPay({
          offer: this.offer,
          payWay: "super_pay"
        }).catch((error: any) => {
          console.log("error", error);
        });
      } else {
        //弹出：
        this.showSuperPayDialog("pay_popup");
        // 记录弹出，让其他弹窗不弹
        this.hasPayBySuperPayToastShowed = true;
      }
    } else {
      if (isIos()) {
        this.payByCreditCard(this.offer).catch((err: any) => {
          this.cancelledPay(err);
        });
      } else {
        const offer = this.offer;
        this.routerPush({
          // name: "Settings",
          name: "Stripe",
          params: {
            routerTransition: "up",
            offer
          }
        });

        // EventBus.$on("card-cancelled", (val: any) => {
        //   setTimeout(() => {
        //     console.log("card-cancelled>>>>>>>收到");
        //     this.payWay = "iap";
        //     console.log("ths.payway:", this.payWay);
        //     this.payByIap(this.offer).catch((err: any) => {});
        //   }, 3000);
        // });
      }
    }
  }

  private get offer() {
    const queryoffer: any = this.$route.query.offer;
    // console.log("payment 页面 获取到的 offer", typeof queryoffer);
    // console.log(JSON.parse(queryoffer));
    return JSON.parse(queryoffer);
  }

  private timeToString(time: any) {
    const m =
      Math.floor((time / 60) % 60) < 10
        ? "0" + Math.floor((time / 60) % 60)
        : Math.floor((time / 60) % 60);
    const s =
      Math.floor(time % 60) < 10
        ? "0" + Math.floor(time % 60)
        : Math.floor(time % 60);
    return (time = m + ":" + s);
  }
}
